export default function (http) {
    return {
        queryByPage(data) {
            return http
                .json({url: `/survey/manage/result/query`, data})
        },

        export(data) {
            return http.json({url: `/survey/result/export`, data})
        },
    }
}


// WEBPACK FOOTER //
// ./src/configure/http/api/questionnaire.js